import { useEffect, useState } from "react";
import { Loader2, Trash2, Upload } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";

const FIELDS = [["app_store_url", "App Store URL (iPhone)"], ["play_store_url", "Google Play URL (Android)"], ["apk_url", "APK URL (if not uploading a file)"], ["version_label", "Version label (e.g. 1.0.0)"]];

export const MobileAppAdmin = () => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/mobile-app").then(({ data }) => setS(data)); }, []);
  if (!s) return null;
  const save = async () => {
    try { setS((await api.put("/admin/mobile-app", Object.fromEntries(FIELDS.map(([k]) => [k, s[k] || null])))).data); toast.success("Mobile app settings saved"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try { const fd = new FormData(); fd.append("file", file); setS((await api.post("/admin/mobile-app/apk", fd)).data); toast.success("APK uploaded"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const removeApk = async () => setS((await api.delete("/admin/mobile-app/apk")).data);
  return (
    <div className="lux-card space-y-5 p-4 sm:p-6" data-testid="mobile-app-admin">
      <p className="lux-eyebrow">Mobile app · download links shown on Get the App</p>
      <div className="grid gap-4 sm:grid-cols-2">
        {FIELDS.map(([k, label]) => (
          <label key={k} className="space-y-1 text-sm"><span className="block text-xs text-zinc-400">{label}</span>
            <input data-testid={`mobile-${k.replace(/_/g, "-")}-input`} className="lux-input" value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} /></label>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <label className="btn-outline-gold cursor-pointer !py-2 text-sm">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} Upload APK
          <input type="file" accept=".apk,application/vnd.android.package-archive" data-testid="mobile-apk-file-input" className="hidden" onChange={(e) => upload(e.target.files?.[0])} /></label>
        {s.apk_uploaded ? (
          <span data-testid="mobile-apk-status" className="flex items-center gap-2 text-xs text-zinc-400">{s.apk_filename} · {(s.apk_size / 1048576).toFixed(1)} MB · {fmtDate(s.apk_uploaded_at)}
            <button data-testid="mobile-apk-remove" onClick={removeApk} className="p-1 text-zinc-500 hover:text-red-300"><Trash2 className="h-4 w-4" /></button></span>
        ) : <span data-testid="mobile-apk-status" className="text-xs text-zinc-500">No APK file uploaded</span>}
      </div>
      <button data-testid="mobile-app-save" onClick={save} className="btn-gold">Save</button>
    </div>
  );
};
